
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'notificationIconContainer': {'display': `flex`,},'notificationBadge': {'color': `secondary`,},'notificationIcon': {'color': `#000000`,'paddingRight': `8px`,'paddingBottom': `5px`,},'redirectLink': {'textDecoration': `none`,'padding': `0`,},
        
      };
    };
  